const updates = [
  {
    id: 1,
    time: '2026-07-29 14:32',
    tag: '独家',
    content: '某知名男团成员被拍到深夜与女经纪人同返公寓，粉丝后援会紧急发文辟谣',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 2,
    time: '2026-07-29 12:15',
    tag: '快讯',
    content: '某头部直播平台再现大规模封号，涉及多位知名带货主播，平台回应称系统升级',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 3,
    time: '2026-07-29 10:48',
    tag: '爆料',
    content: '知情人透露某当红小花已秘密签约海外经纪公司，或将暂别国内娱乐圈一年',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 4,
    time: '2026-07-29 08:20',
    tag: '热点',
    content: '2026暑期档首部爆款剧集诞生，开播三日全网播放量突破15亿，话题阅读量超30亿',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 5,
    time: '2026-07-28 22:05',
    tag: '后续',
    content: '昨日被曝税务问题的网红发布道歉视频，承诺补缴全部税款并暂停直播三个月',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 6,
    time: '2026-07-28 18:30',
    tag: '独家',
    content: '某知名导演新片选角内幕流出，多位一线演员参与试镜，最终阵容即将公布',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 7,
    time: '2026-07-28 15:12',
    tag: '快讯',
    content: '最新一期热门综艺录制因天气原因延期，节目组发文致歉并公布新的录制安排',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 8,
    time: '2026-07-28 11:00',
    tag: '汇总',
    content: '本周吃瓜周报发布：盘点7月最后一周娱乐圈十大热门事件，含独家分析评论',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">最新快讯</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            实时追踪娱乐圈最新动态，51吃瓜网站第一时间为你送上全网最新吃瓜快讯
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[27px] top-0 bottom-0 w-px bg-background-300"></div>

          <div className="flex flex-col gap-6">
            {updates.map((item) => (
              <div key={item.id} className="relative flex gap-4 md:gap-6 pl-12 md:pl-16">
                <div className="absolute left-0 top-1.5 w-[38px] h-[38px] md:w-[54px] md:h-[54px] flex items-center justify-center rounded-full bg-primary-500 text-background-50 z-10">
                  <i className="ri-chat-smile-2-line text-base md:text-xl"></i>
                </div>
                <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-2">
                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}